/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  uid         : 0,          // From Auth
  displayName : 'John Doe', // From Auth
  about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  photoURL    : require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  status      : 'online',
  userRole    : 'admin'
}

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


const baseModals = {
  SettingsModal:{
    show:false,
    content:{
      header:'Settings',
      body:{
      },
      details:null
    }
  },
  AlertModal:{
    show:false,
    content:{
      header:'Alert',
      body:{
      },
      details:null
    }
  },
  FileUploadModal:{
    show:false,
    content:{
      header:'File Upload',
      body:{
      },
      details:null
    }
  }
}

const exampleSecurityObjectList = [
  {
    ObjectID: 77,
    FormName: "PrePulse Claim File",
    ObjectName: "cmdReviewUser"
  }
]

const exampleObjectSecurityList = [
  {
    UserSecurityCode: 22, //auditing L1
    SecurityObjectID: 77,
    Status: 0
  },
  {
    UserSecurityCode: 25, //Auditing L2
    SecurityObjectID: 77,
    Status: 0
  },
  {
    UserSecurityCode: 40, //Auditing L1R
    SecurityObjectID: 77,
    Status: 0
  }
]

const exampleOpenBatchesList = [
  {
    BatchID: 7127,
    ClientName: "Travelers Insurance",
    ClientCode: "TRAVELERSALL..",
    BatchType: "Auto",
    ClaimType: "OTHER, COL",
    ProjType: "Closer File Review",
    Date: "1/24/2020 6:12 PM",
    Remaining: 15280
  }
]

const examplePulseUser = {
  UserSecCode: 22
}


const exampleClientList = [
  {ClientID: 91, ClientGroupName: "AETNA Life Insurance Company"},
  {ClientID: 5, ClientGroupName: "Allstate Insurance Group"},
  {ClientID: 7, ClientGroupName: "American Family Insurance"},
  {ClientID: 90, ClientGroupName: "American Independent Insurance"},
  {ClientID: 84, ClientGroupName: "Ameriprise Auto & Home Insurance"},
  {ClientID: 277, ClientGroupName: "Aspire General Insurance Company"},
  {ClientID: 281, ClientGroupName: "Assurance America"},
  {ClientID: 97, ClientGroupName: "Broadspire"},
  {ClientID: 294, ClientGroupName: "Canal Insurance Group"},
  {ClientID: 99, ClientGroupName: "Cigna Group"},
  {ClientID: 295, ClientGroupName: "Dearborn"},
  {ClientID: 100, ClientGroupName: "Desjardins Group"},
  {ClientID: 287, ClientGroupName: "Diamond Specialty Group"},
  {ClientID: 273, ClientGroupName: "Disability Reinsurance Management Services, Inc."},
  {ClientID: 283, ClientGroupName: "ELCO Administrative Services Company"},
  {ClientID: 240, ClientGroupName: "Everest Insurance Company"},
  {ClientID: 271, ClientGroupName: "Everest WC Suit Review"},
  {ClientID: 267, ClientGroupName: "Farm Family WC Broadspire"},
  {ClientID: 69, ClientGroupName: "Farmers Insurance Group"},
  {ClientID: 82, ClientGroupName: "Florida Farm Bureau Ins Co"},
  {ClientID: 263, ClientGroupName: "Fred Loya Insurance Agency"},
  {ClientID: 29, ClientGroupName: "GEICO Insurance"},
  {ClientID: 280, ClientGroupName: "GEICO WC Broadspire"},
  {ClientID: 37, ClientGroupName: "Infinity Insurance Group"},
  {ClientID: 300, ClientGroupName: "Kentucky National Insurance"},
  {ClientID: 44, ClientGroupName: "Liberty Mutual Insurance"},
  {ClientID: 293, ClientGroupName: "Liberty Mutual Insurance - Commercial"},
  {ClientID: 246, ClientGroupName: "MAPFRE USA"},
  {ClientID: 116, ClientGroupName: "Markel Corporation"},
  {ClientID: 247, ClientGroupName: "Mendota Insurance Company"},
  {ClientID: 30, ClientGroupName: "National General Insurance"},
  {ClientID: 51, ClientGroupName: "Nationwide Insurance Group"},
  {ClientID: 278, ClientGroupName: "Pacific Specialty Insurance Company"},
  {ClientID: 276, ClientGroupName: "Peachtree Insurance Company"},
  {ClientID: 284, ClientGroupName: "Permanent General"},
  {ClientID: 93, ClientGroupName: "Personable Claims Service, Inc."},
  {ClientID: 61, ClientGroupName: "Progressive Insurance Group"},
  {ClientID: 114, ClientGroupName: "Retail Business Services"},
  {ClientID: 241, ClientGroupName: "Sentry Insurance"},
  {ClientID: 108, ClientGroupName: "South Carolina State Accident Fund"},
  {ClientID: 285, ClientGroupName: "Stillwater Insurance"},
  {ClientID: 290, ClientGroupName: "SunLife"},
  {ClientID: 288, ClientGroupName: "The Prudential Insurance Company of America"},
  {ClientID: 242, ClientGroupName: "Travelers Insurance Group"},
  {ClientID: 89, ClientGroupName: "USAA Insurance Company"},
]

//Security Access Levels
//1 = Hide
//0 = Disable (visible)

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  inPrePulse              : true,

  modals                  : baseModals, 
  userInfo                : { UserName: "" },
  selectedClientID        : 0,
  clientSet               : false,
  securityObjectList      : exampleSecurityObjectList,
  objectSecurityList      : exampleObjectSecurityList,
  isAuthorized            : false,
  pulseUser               : examplePulseUser,
  cachedObjectSecurities  : {},
  lookup                  : {},
  lastPulseRoute          : "/pulse/my-stuff",
  lastPrePulseRoute       : "/pre-pulse/my-stuff",
  clientList              : exampleClientList,
  sessionEndingSoon       : false,
  fileUploading           : false

}

export default state
